<div
  class="attributes"
  [ngClass]="rfqExecution ? 'attributes__execution' : 'attributes__main'"
>
  <ng-container *ngIf="legService.activeAttributes().length">
    <ng-container *ngFor="let attribute of legService.activeAttributes()">
      <div
        class="label-container"
        *ngIf="!attribute.hide && !labelsToHide.includes(attribute.shortName)"
      >
        <label
          [ngClass]="{
            'label-container__trade-attribute':
              attribute?.group === 'tradeAttributes'
          }"
        >
          @if (
            genericMultiHedge &&
            rfqExecution &&
            attribute.longName === 'Position'
          ) {
            Client
          }
          {{ attribute.longName }}
        </label>
      </div>
    </ng-container>
  </ng-container>
</div>
